import React from 'react';
import { Box, Typography } from '@mui/material';

const IngestDDQ: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4">Ingest DDQ</Typography>
      <Typography>Welcome to the Ingest DDQ page.</Typography>
    </Box>
  );
};

export default IngestDDQ;